
import React from 'react';
import { Company } from '@/lib/types';
import CompanyBasicInfo from './header/CompanyBasicInfo';
import CompanyBio from './header/CompanyBio';
import CompanyLinks from './header/CompanyLinks';
import CompanyMetrics from './header/CompanyMetrics';
import CompanyHeaderSkeleton from './header/CompanyHeaderSkeleton';
import AddReviewButton from './header/AddReviewButton';
import CompareCompanyButton from './header/CompareCompanyButton';
import CompanyPerks from './CompanyPerks';

interface CompanyHeaderProps {
  company: Company | null;
  companyName: string;
  locations: string[];
  positiveExperiences: number;
  negativeExperiences: number;
  fairWorkCount: number;
  isLoading: boolean;
}

const CompanyHeader = ({
  company,
  companyName,
  locations,
  positiveExperiences,
  negativeExperiences,
  fairWorkCount,
  isLoading
}: CompanyHeaderProps) => {  
  if (isLoading) {
    return <CompanyHeaderSkeleton />;
  }

  return (
    <div className="relative pb-10">
      <div className="flex flex-col md:flex-row justify-between mb-6 gap-4">
        <CompanyBasicInfo 
          company={company} 
          companyName={companyName}
          locations={locations} 
        />
      
        <div className="flex flex-col sm:flex-row gap-2 justify-end">
          <AddReviewButton companyName={companyName} />
        </div>
      </div>
      
      <div className="mb-6">
        <CompanyBio company={company} companyName={companyName} />
      </div>
      
      <div className="flex flex-col md:flex-row justify-between gap-4">
        <div className="flex flex-col gap-4">
          <CompanyMetrics 
            positiveExperiences={positiveExperiences}
            negativeExperiences={negativeExperiences}
            fairWorkCount={fairWorkCount}
          />
          
          {/* Perks button now appears directly below metrics */}
          {company && <CompanyPerks companyId={company.id} companyName={companyName} showAsInline={true} />}
        </div>
        
        <CompanyLinks company={company} companyName={companyName} />
      </div>
      
      {/* Compare button positioned at bottom left with extra spacing */}
      <div className="absolute -bottom-2 left-0">
        <CompareCompanyButton companyName={companyName} />
      </div>
    </div>
  );
};

export default CompanyHeader;
